export type FiltroComandas = 'todas' | 'livres' | 'ocupadas';

type ComandaFiltravel = { nome?: string; clienteNome?: string; sk?: string | null };

export function filtrarComandas<T extends ComandaFiltravel>(lista: T[], busca: string | undefined, status: FiltroComandas): T[] {
  const texto = busca?.toLowerCase();
  return lista.filter(item => {
    const correspondeBusca = !texto || item.nome?.toLowerCase().includes(texto) || item.clienteNome?.toLowerCase().includes(texto);
    const aberta = Boolean(item.sk);
    return correspondeBusca && (status === 'todas' || (status === 'ocupadas' ? aberta : !aberta));
  });
}
